import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    position: relative;
    background-color: ${colors.white};
    padding: 50px 0;

    > * {
        position: relative;
        z-index: 1;
    }
`;

export const Title = styled.h3`
    font-size: 25px;
    margin: 0;

    ${breakpoints.large} {
        text-align: left;
        font-size: 32px;
    }
`;

export const Copy = styled.p`
    margin-top: 12px;
    font-size: 16px;
    ${breakpoints.medium} {
        font-size: 18px;
    }
`;

export const Inner = styled.div`
    margin-bottom: 30px;

    ${breakpoints.medium} {
        display: flex;
        justify-content: space-between;
    }
`;
